import React, { useCallback, useEffect } from 'react';
import { ApolloError } from '@apollo/client';
import { ErrorBanner } from '../design_system/ErrorBanner';
import { useErrorState } from '../stores/useErrorState';
import { useClearUploadFileErrorTimeout } from '../hooks/useClearUploadFileErrorTimeout';
import { O, pipe } from '../lib/EffectExports';
import { errorBannerCounter } from '../lib/metrics';
import { ErrorCodes } from '../constants/ErrorCodes';
import { log } from '../lib/logger';
import { useShowChatboxStore } from '../stores/showChatboxStore';
import { useLineOfBusiness } from '../hooks/useLineOfBusiness';
import { useClearSecureFormErrorTimeout } from '../hooks/useClearSecureFormErrorTimeout';
export const ErrorBannerController = () => {
    const { lineOfBusiness } = useLineOfBusiness();
    const { errorState, setErrorState } = useErrorState();
    const [, setOpen] = useShowChatboxStore(lineOfBusiness);
    const handleClose = useCallback(event => {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setOpen(false);
        setErrorState(undefined);
    }, [setErrorState, setOpen]);
    useClearUploadFileErrorTimeout();
    useClearSecureFormErrorTimeout();
    const isSessionIdNullOrEmptyError = pipe(errorState, O.map(error => {
        return (error.originalError instanceof ApolloError &&
            error.originalError.graphQLErrors.some(err => err.extensions.errorType === 'SESSION_ID_IS_NULL_OR_EMPTY'));
    }), O.getOrElse(() => false));
    const isSupportCaseMismatch = pipe(errorState, O.map(error => error.originalError instanceof ApolloError &&
        error.originalError.graphQLErrors.some(err => err.extensions.errorType === 'SUPPORT_CASE_MISMATCH')), O.getOrElse(() => false));
    useEffect(() => {
        O.match(errorState, {
            onNone: () => null,
            onSome: error => {
                errorBannerCounter(lineOfBusiness, isSupportCaseMismatch
                    ? ErrorCodes.SUPPORT_CASE_MISMATCH_ERROR
                    : error.code).catch(log.error);
            },
        });
    }, [errorState]);
    return O.match(errorState, {
        onNone: () => null,
        onSome: error => {
            return (React.createElement(React.Fragment, null,
                React.createElement(ErrorBanner, { state: isSessionIdNullOrEmptyError || isSupportCaseMismatch
                        ? 'need-close'
                        : 'need-refresh', onCloseClick: handleClose, message: error.code === ErrorCodes.UPLOAD_FILE_ERROR ||
                        error.code === ErrorCodes.SECURE_FORM_ALREADY_SUBMITTED
                        ? error.message
                        : undefined })));
        },
    });
};
//# sourceMappingURL=ErrorBannerController.js.map